import { currencyGet, currencyPost, expectItems, type ApiEnvelope } from '@/lib/task-api';
import type { ServerPage, ServerListPageArgs } from '@/lib/task-server-list';
import { toOfferRow, type OfferRow } from '@/features/tasks/types';

/**
 * TEKLIF UCLARI.
 *
 * `/v1/offers` GET  : listeleme. SAHIPLIK SUNUCUDA zorlanir — buro yalniz kendi
 *                     tekliflerini, musteri yalniz kendi taleplerine gelenleri
 *                     gorur. Istemcinin gonderdigi filtreler bunun ustune biner,
 *                     yerine gecmez.
 * `/v1/offers` POST : teklif ver / GUNCELLE. `(offer_user_id, task_id)` cifti
 *                     BENZERSIZ: bir buro bir goreve EN FAZLA BIR KEZ teklif
 *                     verebilir. Ikinci bir "olustur" cagrisi yeni satir degil,
 *                     benzersizlik ihlali uretir — bu yuzden arayuz "zaten
 *                     teklif verdim" durumunu DUZENLEMEYE yonlendirir.
 */

type ListResponse = ApiEnvelope & {
  items?: unknown;
  page?: ServerPage<OfferRow>['page'];
};

export const fetchOfferPage = async ({
  params,
  limit,
  offset,
  snapshotAt,
}: ServerListPageArgs): Promise<ServerPage<OfferRow>> => {
  const { data, receivedAtMs } = await currencyGet<ListResponse>('/v1/offers', {
    ...params,
    limit,
    offset,
    ...(snapshotAt === null ? {} : { snapshotAt }),
  });
  return {
    items: expectItems(data, '/v1/offers').map(toOfferRow),
    page: data.page ?? {},
    receivedAtMs,
  };
};

export type UpsertOfferInput = {
  offerUserId: string;
  taskId: string;
  /** BIRIM KUR — islemin toplami degil. */
  offerPrice: number;
  offerData: Record<string, unknown>;
};

/**
 * Teklif ver ya da guncelle. Tek uc: sunucu benzersizlik cifti uzerinden
 * hangisi oldugunu kendisi biliyor.
 */
export const upsertOffer = (input: UpsertOfferInput): Promise<ApiEnvelope> =>
  currencyPost<ApiEnvelope>('/v1/offers', { ...input });
